(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 4269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ useHomeContext; },
/* harmony export */   "Q": function() { return /* binding */ HomeContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

var HomeContext = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
  highlightBlogs: []
});
var useHomeContext = function useHomeContext() {
  return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(HomeContext);
};

/***/ }),

/***/ 5109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "A": function() { return /* reexport */ Layout_Layout; }
});

// EXTERNAL MODULE: ./components/Footer/index.ts + 2 modules
var Footer = __webpack_require__(2689);
// EXTERNAL MODULE: ./components/Navbar/index.ts + 7 modules
var Navbar = __webpack_require__(7430);
// EXTERNAL MODULE: ./node_modules/react-no-ssr/index.js
var react_no_ssr = __webpack_require__(6467);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/Layout/Layout.tsx






var Layout = function Layout(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "h-full w-full overflow-hidden mx-auto",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(react_no_ssr["default"], {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Navbar/* Navbar */.w, {})
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("main", {
      children: children
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Footer/* Footer */.$, {})]
  });
};

/* harmony default export */ var Layout_Layout = (Layout);
;// CONCATENATED MODULE: ./components/Layout/index.ts


/***/ }),

/***/ 8008:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./components/Layout/index.ts + 1 modules
var Layout = __webpack_require__(5109);
// EXTERNAL MODULE: ./components/shared/FormContact.tsx + 7 modules
var FormContact = __webpack_require__(7878);
// EXTERNAL MODULE: ./components/Contexts/LocaleContext.tsx
var LocaleContext = __webpack_require__(5314);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
;// CONCATENATED MODULE: ./components/Home/DigitalTransformationSection/DigitalTransformationSection.tsx





var DigitalTransformationSection = function DigitalTransformationSection() {
  var _useLocale = (0,LocaleContext/* useLocale */.b)(),
      lang = _useLocale.lang;

  var descriptions = {
    th: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: ["\u0E40\u0E21\u0E37\u0E48\u0E2D \u201C\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u201D \u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A Digital ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {
        className: "md:hidden"
      }), "\u0E17\u0E38\u0E01\u0E1B\u0E31\u0E0D\u0E2B\u0E32\u0E08\u0E30\u0E2B\u0E21\u0E14\u0E44\u0E1B"]
    }),
    en: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: ["When data goes digital,", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("br", {
        className: "md:hidden"
      }), "complexity becomes clarity."]
    })
  };
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: "relative overflow-hidden md:h-[250px] lg:h-[550px]",
    "aria-labelledby": "digital-transformation",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("video", {
      autoPlay: true,
      muted: true,
      loop: true,
      playsInline: true,
      preload: "auto",
      disablePictureInPicture: true,
      className: "w-full",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)("source", {
        src: "/videos/homepage-bg-video-1.mp4",
        type: "video/mp4"
      }), "Your browser does not support the video tag."]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "absolute inset-0 w-full h-full flex justify-center items-center",
      style: {
        background: 'linear-gradient(180deg, #0A1027 0%, rgba(10, 16, 39, 0) 38.73%)'
      },
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "Container flex-column gap-5 md:gap-8 text-center",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h2", {
          className: "text-h4Bold md:text-dSmallBold lg:text-dLargeBold",
          children: "Data should go digital!"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "text-p2Semibold md:text-h5Semibold",
          children: descriptions[lang]
        })]
      })
    })]
  });
};

/* harmony default export */ var DigitalTransformationSection_DigitalTransformationSection = (DigitalTransformationSection);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./components/Common/index.ts + 2 modules
var Common = __webpack_require__(4565);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 109 modules
var motion = __webpack_require__(3253);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./components/AutoSlide/AutoSlide.tsx




var AutoSlide = function AutoSlide(_ref) {
  var children = _ref.children,
      _ref$containerWidth = _ref.containerWidth,
      containerWidth = _ref$containerWidth === void 0 ? 0 : _ref$containerWidth,
      _ref$duration = _ref.duration,
      duration = _ref$duration === void 0 ? 30 : _ref$duration,
      _ref$pauseOnHover = _ref.pauseOnHover,
      pauseOnHover = _ref$pauseOnHover === void 0 ? true : _ref$pauseOnHover;

  var _useState = (0,react.useState)(false),
      isHovered = _useState[0],
      setIsHovered = _useState[1];

  var handleTouchStart = function handleTouchStart() {
    if (pauseOnHover) {
      setIsHovered(true); // หยุดการสไลด์เมื่อแตะ
    }
  };

  var handleTouchEnd = function handleTouchEnd() {
    setIsHovered(false); // เริ่มการสไลด์ใหม่เมื่อไม่แตะ
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: "overflow-hidden",
    onTouchStart: handleTouchStart // เมื่อแตะเริ่มหยุด
    ,
    onTouchEnd: handleTouchEnd // เมื่อเลิกแตะเริ่มสไลด์ใหม่
    ,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
      className: "flex",
      initial: {
        x: '0%'
      },
      animate: {
        x: isHovered && pauseOnHover ? 'inherit' : '-100%'
      } // ถ้าแตะหยุดการสไลด์
      ,
      transition: {
        duration: duration,
        // speed
        ease: 'linear',
        repeat: Infinity // Loop infinitely

      },
      style: {
        width: "".concat(containerWidth / 2, "px")
      },
      whileHover: pauseOnHover ? {
        x: 'inherit'
      } : {} // Keep the current position when hovering
      ,
      children: children
    })
  });
};

/* harmony default export */ var AutoSlide_AutoSlide = (AutoSlide);
;// CONCATENATED MODULE: ./components/Home/HeroSection/HeroSection.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var HeroSection_hidden = {
  opacity: 0,
  y: 20
};
var visible = {
  opacity: 1,
  y: 0
};
var transition = {
  duration: 0.7
};
var backgrounds = [{
  src: '/images/new-homepage/bg-homepage-sm.webp',
  width: 375,
  height: 667,
  objectPosition: 'center',
  className: 'md:hidden'
}, {
  src: '/images/new-homepage/bg-homepage-md.webp',
  width: 744,
  height: 618,
  objectPosition: 'right center',
  className: 'hidden md:block lg:hidden'
}, {
  src: '/images/new-homepage/bg-homepage-lg.webp',
  width: 1440,
  height: 712,
  objectPosition: 'right center',
  className: 'hidden lg:block'
}];
var partners = [{
  name: 'bls',
  src: '/images/new-homepage/partners/bls_logo_white.webp',
  alt: 'BLS',
  width: 120,
  height: 75
}, {
  name: 'power-buy',
  src: '/images/new-homepage/partners/power_buy.webp',
  alt: 'Power Buy',
  width: 120,
  height: 75
}, {
  name: 'yamaha',
  src: '/images/new-homepage/partners/yamaha.webp',
  alt: 'Siam Music Yamaha',
  width: 120,
  height: 75
}, {
  name: 'hitachi',
  src: '/images/new-homepage/partners/hitachi.webp',
  alt: 'Hitachi',
  width: 120,
  height: 75
}, {
  name: 'scg',
  src: '/images/new-homepage/partners/scg.webp',
  alt: 'SCG',
  width: 120,
  height: 75
}, {
  name: 'komatsu',
  src: '/images/new-homepage/partners/komatsu.webp',
  alt: 'Komatsu',
  width: 120,
  height: 75
}];

var HeroSection = function HeroSection(_ref) {
  var click = _ref.click;

  var _useLocale = (0,LocaleContext/* useLocale */.b)(),
      lang = _useLocale.lang;

  var ref = (0,react.useRef)(null);

  var _useState = (0,react.useState)(0),
      containerWidth = _useState[0],
      setContainerWidth = _useState[1];

  var calculateContainerWidth = (0,react.useCallback)(function () {
    if (ref.current) {
      var children = Array.from(ref.current.children);
      var totalWidth = children.reduce(function (sum, child) {
        var childWidth = child.getBoundingClientRect().width;
        return sum + childWidth;
      }, 0);
      setContainerWidth(totalWidth);
    }
  }, []);
  (0,react.useEffect)(function () {
    calculateContainerWidth();
    window.addEventListener('resize', calculateContainerWidth); // Clean up the event listener

    return function () {
      window.removeEventListener('resize', calculateContainerWidth);
    };
  }, [calculateContainerWidth]);
  var titleContent = {
    en: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: ["Simplifying Your Digital ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {
        className: "hidden lg:block"
      }), "Transformation Journey. ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {
        className: "hidden lg:block"
      }), "Customer First, Digital First."]
    }),
    th: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: ["\u0E43\u0E2B\u0E49 CODIUM \u0E40\u0E1B\u0E47\u0E19\u0E41\u0E23\u0E07\u0E02\u0E31\u0E1A\u0E40\u0E04\u0E25\u0E37\u0E48\u0E2D\u0E19\u0E18\u0E38\u0E23\u0E01\u0E34\u0E08\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E43\u0E19\u0E22\u0E38\u0E04\u0E14\u0E34\u0E08\u0E34\u0E17\u0E31\u0E25", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("br", {
        className: "hidden lg:block"
      }), "\u0E14\u0E49\u0E27\u0E22\u0E42\u0E0B\u0E25\u0E39\u0E0A\u0E31\u0E19\u0E17\u0E35\u0E48\u0E0A\u0E48\u0E27\u0E22\u0E17\u0E33\u0E43\u0E2B\u0E49\u0E01\u0E32\u0E23\u0E08\u0E31\u0E14\u0E01\u0E32\u0E23 Work Flow Digitalization", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("br", {
        className: "hidden lg:block"
      }), "\u0E41\u0E25\u0E30\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E40\u0E1B\u0E47\u0E19\u0E40\u0E23\u0E37\u0E48\u0E2D\u0E07\u0E07\u0E48\u0E32\u0E22\u0E2A\u0E33\u0E2B\u0E23\u0E31\u0E1A\u0E1A\u0E23\u0E34\u0E29\u0E31\u0E17\u0E04\u0E38\u0E13"]
    })
  };
  var descriptions = {
    th: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: ["CODIUM \u0E04\u0E37\u0E2D\u0E1C\u0E39\u0E49\u0E19\u0E33\u0E14\u0E49\u0E32\u0E19 Digital Native Company as a Service \u0E43\u0E19\u0E1B\u0E23\u0E30\u0E40\u0E17\u0E28\u0E44\u0E17\u0E22", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("br", {
        className: "hidden lg:block"
      }), "\u0E1C\u0E39\u0E49\u0E40\u0E0A\u0E35\u0E48\u0E22\u0E27\u0E0A\u0E32\u0E0D\u0E14\u0E49\u0E32\u0E19 Work Flow Digitalization \u0E41\u0E25\u0E30\u0E02\u0E49\u0E2D\u0E21\u0E39\u0E25\u0E43\u0E19\u0E23\u0E39\u0E1B\u0E41\u0E1A\u0E1A\u0E14\u0E34\u0E08\u0E34\u0E17\u0E31\u0E25", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("br", {
        className: "hidden lg:block"
      }), "\u0E40\u0E1B\u0E25\u0E35\u0E48\u0E22\u0E19\u0E41\u0E1B\u0E25\u0E07\u0E01\u0E23\u0E30\u0E1A\u0E27\u0E19\u0E01\u0E32\u0E23\u0E17\u0E33\u0E07\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E14\u0E49\u0E27\u0E22\u0E42\u0E0B\u0E25\u0E39\u0E0A\u0E31\u0E19\u0E14\u0E34\u0E08\u0E34\u0E17\u0E31\u0E25\u0E41\u0E1A\u0E1A\u0E04\u0E23\u0E1A\u0E27\u0E07\u0E08\u0E23", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("br", {
        className: "hidden lg:block"
      }), "\u0E17\u0E35\u0E48\u0E2D\u0E2D\u0E01\u0E41\u0E1A\u0E1A\u0E21\u0E32\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E0A\u0E48\u0E27\u0E22\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E17\u0E33\u0E07\u0E32\u0E19\u0E44\u0E14\u0E49\u0E40\u0E23\u0E47\u0E27\u0E02\u0E36\u0E49\u0E19 \u0E09\u0E25\u0E32\u0E14\u0E02\u0E36\u0E49\u0E19 \u0E41\u0E25\u0E30\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22\u0E22\u0E34\u0E48\u0E07\u0E02\u0E36\u0E49\u0E19"]
    }),
    en: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: ["CODIUM is Thailand's leading provider of Digital Native Company as a Service, ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {
        className: "hidden lg:block"
      }), "specializing in digital document and data management.", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("br", {
        className: "hidden lg:block"
      }), "Transform your workflows with our all-in-one digital solutions,", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("br", {
        className: "hidden lg:block"
      }), "designed to help you work faster, smarter, and more securely."]
    })
  };
  var partnerText = {
    th: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: "CODIUM \u0E43\u0E2B\u0E49\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E1A\u0E23\u0E34\u0E29\u0E31\u0E17\u0E0A\u0E31\u0E49\u0E19\u0E19\u0E33\u0E43\u0E19\u0E1B\u0E23\u0E30\u0E40\u0E17\u0E28\u0E44\u0E17\u0E22\u0E01\u0E27\u0E48\u0E32 500 \u0E1A\u0E23\u0E34\u0E29\u0E31\u0E17"
    }),
    en: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
      children: "CODIUM serves the top companies in Thailand"
    })
  };
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    className: "relative",
    "aria-labelledby": "hero-section",
    role: "banner",
    children: [backgrounds.map(function (_ref2) {
      var src = _ref2.src,
          width = _ref2.width,
          height = _ref2.height,
          objectPosition = _ref2.objectPosition,
          className = _ref2.className;
      return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "".concat(className, " min-h-[667px] h-[calc(100vh-3rem)] md:h-[calc(100vh-3.5rem)]"),
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: src,
          alt: "Hero section background",
          layout: "fill",
          objectFit: "cover",
          objectPosition: objectPosition,
          loading: "lazy"
        })
      }, src);
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "absolute top-0 w-full h-full flex flex-col justify-between items-center xl:items-start py-12 md:py-[60px] xxl:py-[75px]",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "Container flex-column items-center lg:items-start gap-5 md:gap-8 px-2",
        children: [lang === 'en' ? /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.h1 */.E.h1, {
          className: "gradient-head-large text-center text-h5Semibold md:text-h2Bold md:leading-[3.5rem] lg:text-dSmallBold lg:text-left px-2",
          initial: HeroSection_hidden,
          animate: visible,
          transition: transition,
          children: titleContent[lang]
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.h1 */.E.h1, {
          className: "gradient-head-large text-center text-h6Semibold leading-8 md:text-h4Semibold md:leading-10 lg:text-left px-2",
          initial: HeroSection_hidden,
          animate: visible,
          transition: transition,
          children: titleContent[lang]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.p */.E.p, {
          className: "text-p2Regular lg:text-p1Regular text-center lg:text-left px-2",
          initial: HeroSection_hidden,
          animate: visible,
          transition: _objectSpread(_objectSpread({}, transition), {}, {
            delay: 0.25
          }),
          children: descriptions[lang]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "px-2",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(Common/* Button */.z, {
            id: "contact-us-esignature",
            icon: "/icons/speech.svg",
            text: lang === 'en' ? 'CONTACT US' : 'ติดต่อเรา',
            className: "text-sm border border-white",
            onClick: click
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "Container flex-column gap-2.5 pb-6 lg:pb-0 mx-auto w-full",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "text-center text-p2Medium",
          children: partnerText[lang]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "md:hidden overflow-hidden pb-3",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(AutoSlide_AutoSlide, {
            containerWidth: containerWidth,
            duration: 50,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              ref: ref,
              className: "flex items-center",
              children: [].concat(partners, partners).map(function (_ref3, index) {
                var name = _ref3.name,
                    src = _ref3.src,
                    alt = _ref3.alt,
                    width = _ref3.width,
                    height = _ref3.height;
                return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "flex items-center",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "min-w-[100px] h-full flex justify-center items-center",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                      src: src,
                      alt: alt,
                      width: width,
                      height: height,
                      objectFit: "contain",
                      loading: "lazy"
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "w-2 h-6 mx-2 flex justify-center items-center",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                      className: "w-0.5 h-full bg-white"
                    })
                  })]
                }, "".concat(name, "-").concat(index));
              })
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "hidden md:flex justify-center items-center px-3",
          children: partners.map(function (_ref4, index) {
            var name = _ref4.name,
                src = _ref4.src,
                alt = _ref4.alt,
                width = _ref4.width,
                height = _ref4.height;
            return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "flex items-center",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                src: src,
                alt: alt,
                width: width,
                height: height,
                objectFit: "scale-down",
                loading: "lazy"
              }), index < partners.length - 1 && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "w-0.5 h-5 bg-white mx-4"
              })]
            }, name);
          })
        })]
      })]
    })]
  });
};

/* harmony default export */ var HeroSection_HeroSection = (HeroSection);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/utils/use-in-view.mjs + 3 modules
var use_in_view = __webpack_require__(7037);
;// CONCATENATED MODULE: ./components/CarouselNewDesign/CarouselNewDesign.tsx





var CarouselNewDesign = function CarouselNewDesign(_ref) {
  var children = _ref.children,
      _ref$percent_width = _ref.percent_width,
      percent_width = _ref$percent_width === void 0 ? 100 : _ref$percent_width,
      _ref$position_x = _ref.position_x,
      position_x = _ref$position_x === void 0 ? 100 : _ref$position_x,
      _ref$interval = _ref.interval,
      interval = _ref$interval === void 0 ? 3000 : _ref$interval,
      _ref$autoSlide = _ref.autoSlide,
      autoSlide = _ref$autoSlide === void 0 ? false : _ref$autoSlide,
      _ref$isHovered = _ref.isHovered,
      isHovered = _ref$isHovered === void 0 ? false : _ref$isHovered,
      height = _ref.height,
      currentSlide = _ref.currentSlide;

  var _useState = (0,react.useState)(0),
      current = _useState[0],
      setCurrent = _useState[1];

  var ref = (0,react.useRef)(null);
  var isInView = (0,use_in_view/* useInView */.Y)(ref, {
    amount: 0.5,
    once: true
  });
  var next = (0,react.useCallback)(function () {
    setCurrent(function (curr) {
      return curr === children.length - 1 ? 0 : curr + 1;
    });
  }, [children.length]);
  (0,react.useEffect)(function () {
    var slideInterval;

    if (isInView && autoSlide && !isHovered) {
      slideInterval = setInterval(next, interval);
    }

    return function () {
      if (slideInterval) {
        clearInterval(slideInterval);
      }
    };
  }, [autoSlide, next, isHovered, isInView, interval]);
  (0,react.useEffect)(function () {
    if (autoSlide) {
      currentSlide(current);
    }
  }, [current]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    ref: ref,
    className: "overflow-x-scroll scrollbar-none scroll-smooth relative",
    style: {
      width: "".concat(percent_width, "%")
    },
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "overflow-hidden rounded-[20px] w-full",
      style: height ? {
        height: "".concat(height, "px")
      } : {},
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
        className: "flex",
        animate: {
          x: isInView ? "-".concat(current * position_x, "%") : '0%'
        } // Moves left based on current slide
        ,
        transition: {
          type: 'tween',
          duration: 0.5,
          ease: 'easeInOut'
        } // Smooth animation
        ,
        children: children
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "flex items-center justify-center gap-2 pt-8",
      children: children.map(function (_, i) {
        return /*#__PURE__*/(0,jsx_runtime.jsx)("button", {
          id: "bullet-".concat(i),
          "aria-label": "bullet-".concat(i),
          className: "transition-all w-2 h-2 bg-aqua rounded-full slide-out cursor-pointer bg-white ".concat(current === i ? 'p-0.5' : 'bg-opacity-50'),
          onClick: function onClick() {
            setCurrent(i);
          }
        }, i);
      })
    })]
  });
};

/* harmony default export */ var CarouselNewDesign_CarouselNewDesign = (CarouselNewDesign);
;// CONCATENATED MODULE: ./components/Home/ServiceSection/BusinessOutcomes.tsx









var imagePath = '/images/new-homepage/business-outcome-images/';
var businessOutcomes = [{
  icon: '/icons/city.svg',
  name_en: 'Real Estate',
  name_th: 'อสังหาริมทรัพย์',
  image: imagePath + 'real-estate.webp'
}, {
  icon: '/icons/car.svg',
  name_en: 'Automotive',
  name_th: 'ยานยนต์',
  image: imagePath + 'automotive.webp',
  object_position: '50% 35%'
}, {
  icon: '/icons/magnet-energy.svg',
  name_en: 'Energy',
  name_th: 'พลังงาน',
  image: imagePath + 'energy.webp',
  object_position: '50% 35%'
}, {
  icon: '/icons/piggy-bank.svg',
  name_en: 'Finance',
  name_th: 'การเงิน',
  image: imagePath + 'finance.webp',
  object_position: '50% 40%'
}, {
  icon: '/icons/small-shop-alt.svg',
  name_en: 'Hospitality',
  name_th: 'โรงแรม ร้านอาหาร',
  image: imagePath + 'hospitality.webp'
}, {
  icon: '/icons/internet.svg',
  name_en: 'Technology',
  name_th: 'ไอที',
  image: imagePath + 'technology.webp'
}, {
  icon: '/icons/industry.svg',
  name_en: 'Manufacturing',
  name_th: 'อุตสาหกรรมการผลิต',
  image: imagePath + 'manufacturing.webp'
}, {
  icon: '/icons/pharmacy-cross-circle.svg',
  name_en: 'Medical & Health',
  name_th: 'การแพทย์และสุขภาพ',
  image: imagePath + 'medical-and-health.webp'
}, {
  icon: '/icons/bank.svg',
  name_en: 'Government',
  name_th: 'ภาครัฐ',
  image: imagePath + 'government.webp'
}, {
  icon: '/icons/plus.svg',
  name_en: 'Others',
  name_th: 'และธุรกิจอื่นๆ',
  image: imagePath + 'others.webp'
}];

var BusinessOutcomes = function BusinessOutcomes() {
  var _useLocale = (0,LocaleContext/* useLocale */.b)(),
      lang = _useLocale.lang;

  var containerRef = (0,react.useRef)(null);
  var autoSlideRef = (0,react.useRef)(null);

  var _useState = (0,react.useState)(0),
      autoSlideWidth = _useState[0],
      setAutoSlideWidth = _useState[1];

  var _useState2 = (0,react.useState)(0),
      currentSlide = _useState2[0],
      setCurrentSlide = _useState2[1];

  (0,react.useEffect)(function () {
    if (autoSlideRef.current) {
      var width = autoSlideRef.current.getBoundingClientRect().width;
      setAutoSlideWidth(width);
    }
  }, [autoSlideRef]);
  var title = lang === 'en' ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: ["We're not just about ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {
      className: "md:hidden"
    }), "products\u2014", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {
      className: "hidden md:block"
    }), "we're about delivering impactful ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {
      className: "hidden md:block"
    }), "business outcomes."]
  }) : 'ออกแบบระบบให้เหมาะกับธุรกิจของคุณ';
  var description = lang === 'en' ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: ["No matter your industry, we\u2019re here to elevate your business to the digital age. ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {
      className: "md:hidden xxl:block"
    }), "Our solutions are tailored to meet the unique needs of each business,", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("br", {
      className: "md:hidden xxl:block"
    }), "simplifying processes and enhancing security to fit your organization perfectly."]
  }) : /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: ["\u0E44\u0E21\u0E48\u0E27\u0E48\u0E32\u0E04\u0E38\u0E13\u0E08\u0E30\u0E2D\u0E22\u0E39\u0E48\u0E43\u0E19\u0E18\u0E38\u0E23\u0E01\u0E34\u0E08\u0E41\u0E1A\u0E1A\u0E43\u0E14 \u0E40\u0E23\u0E32\u0E1E\u0E23\u0E49\u0E2D\u0E21\u0E22\u0E01\u0E23\u0E30\u0E14\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E17\u0E33\u0E07\u0E32\u0E19\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13\u0E2A\u0E39\u0E48\u0E14\u0E34\u0E08\u0E34\u0E17\u0E31\u0E25", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "\u0E14\u0E49\u0E27\u0E22\u0E23\u0E30\u0E1A\u0E1A\u0E17\u0E35\u0E48\u0E2D\u0E2D\u0E01\u0E41\u0E1A\u0E1A\u0E21\u0E32\u0E43\u0E2B\u0E49\u0E23\u0E2D\u0E07\u0E23\u0E31\u0E1A\u0E04\u0E27\u0E32\u0E21\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E40\u0E09\u0E1E\u0E32\u0E30\u0E02\u0E2D\u0E07\u0E41\u0E15\u0E48\u0E25\u0E30\u0E2D\u0E38\u0E15\u0E2A\u0E32\u0E2B\u0E01\u0E23\u0E23\u0E21", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("br", {
      className: "md:hidden lg:block"
    }), "\u0E0A\u0E48\u0E27\u0E22\u0E43\u0E2B\u0E49\u0E04\u0E38\u0E13\u0E25\u0E14\u0E04\u0E27\u0E32\u0E21\u0E22\u0E38\u0E48\u0E07\u0E22\u0E32\u0E01 \u0E41\u0E25\u0E30\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E04\u0E27\u0E32\u0E21\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22\u0E43\u0E19\u0E01\u0E32\u0E23\u0E17\u0E33\u0E07\u0E32\u0E19\u0E17\u0E35\u0E48\u0E40\u0E2B\u0E21\u0E32\u0E30\u0E01\u0E31\u0E1A\u0E18\u0E38\u0E23\u0E01\u0E34\u0E08\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13"]
  });
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    "aria-labelledby": "business-outcomes",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "Container flex-column lg:flex-row justify-between items-center gap-10",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        ref: containerRef,
        className: "w-full lg:w-[65%] flex-column gap-10",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Common/* Title */.D, {
          className: "md:text-left",
          children: title
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
          className: "p-text text-center md:text-left",
          children: description
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "block md:hidden",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(AutoSlide_AutoSlide, {
            containerWidth: autoSlideWidth,
            children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              ref: autoSlideRef,
              className: "flex",
              children: businessOutcomes.map(function (item, index) {
                return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
                  className: "flex items-center gap-2 px-4",
                  children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                    className: "w-10 h-10 flex justify-center items-center rounded-lg bg-[#FFFFFF33]",
                    children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                      src: item.icon,
                      alt: item.name_en,
                      width: 24,
                      height: 24
                    })
                  }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                    className: "whitespace-nowrap",
                    children: lang === 'en' ? item.name_en : item.name_th
                  })]
                }, index);
              })
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "hidden md:grid grid-cols-2",
          children: businessOutcomes.map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
              className: "flex items-center gap-2 pr-8 py-4",
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "w-10 h-10 flex justify-center items-center rounded-lg bg-[#FFFFFF33]",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                  src: item.icon,
                  alt: item.name_en,
                  width: 24,
                  height: 24
                })
              }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
                className: "whitespace-nowrap",
                children: lang === 'en' ? item.name_en : item.name_th
              })]
            }, index);
          })
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "relative lg:w-[30%]",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "lg:hidden",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CarouselNewDesign_CarouselNewDesign, {
            percent_width: 100,
            autoSlide: true,
            height: 350,
            currentSlide: function currentSlide(e) {
              return setCurrentSlide(e);
            },
            children: businessOutcomes.map(function (item) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                src: item.image,
                alt: item.name_en,
                className: "w-full h-[350px] object-cover flex-shrink-0",
                style: item.object_position ? {
                  objectPosition: item.object_position
                } : {}
              }, item.name_en);
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "hidden lg:block",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CarouselNewDesign_CarouselNewDesign, {
            percent_width: 100,
            autoSlide: true,
            currentSlide: function currentSlide(e) {
              return setCurrentSlide(e);
            },
            children: businessOutcomes.map(function (item) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
                src: item.image,
                alt: item.name_en,
                style: {
                  width: '100%',
                  objectFit: 'cover'
                }
              }, item.name_en);
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "absolute inset-0 flex items-end mb-10",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "absolute inset-0 rounded-[20px]",
            style: {
              background: 'linear-gradient(180deg, rgba(0, 0, 0, 0) 76.89%, #000000 96.41%)'
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "relative m-5 px-2.5 border-l-4 border-red-500",
            children: lang === 'en' ? businessOutcomes[currentSlide].name_en : businessOutcomes[currentSlide].name_th
          })]
        })]
      })]
    })
  });
};

/* harmony default export */ var ServiceSection_BusinessOutcomes = (BusinessOutcomes);
;// CONCATENATED MODULE: ./components/Home/ServiceSection/CustomerSection.tsx






var logoPath = '/images/new-homepage/customer-images/';
/*
แนะนำให้จัดขนาดโลโก้ใน Figma ก่อน:
1. นำโลโก้เข้า Figma และสร้าง Frame ขนาด 150×150 px
2. ปรับขนาดรูปให้อยู่กึ่งกลางของ Frame เพื่อให้โลโก้ทั้งหมดมีขนาดเท่ากัน ฉันใช้ขนาดกว้าง 150 px หรือปรับตามความเหมาะสม
3. ใช้ Plugin "WebP Exporter" เพื่อ Export ไฟล์เป็น .webp ช่วยลดขนาดไฟล์โดยไม่เสียคุณภาพ (Export แบบ 2x จะได้รูปชัดกว่า)
*/

var customers = [{
  name: 'scg',
  src: 'scg.webp',
  alt: 'Siam Cement Group',
  width: 150,
  height: 150
}, {
  name: 'bls-bcap',
  src: 'bls_bcap.webp',
  alt: 'BLS BCAP',
  width: 150,
  height: 150
}, {
  name: 'power-buy',
  src: 'power_buy.webp',
  alt: 'Power Buy',
  width: 150,
  height: 150
}, {
  name: 'komatsu',
  src: 'komatsu.webp',
  alt: 'Komatsu',
  width: 150,
  height: 150
}, {
  name: 'siam-motors-group',
  src: 'siam_motors_group.webp',
  alt: 'Siam Motors Group',
  width: 150,
  height: 150
}, {
  name: 'aira-alful',
  src: 'aira_alful.webp',
  alt: 'Aira Alful',
  width: 150,
  height: 150
}, {
  name: 'hitachi',
  src: 'hitachi.webp',
  alt: 'Hitachi',
  width: 150,
  height: 150
}, {
  name: 'siam-music-yamaha',
  src: 'siam_music_yamaha.webp',
  alt: 'Siam Music Yamaha',
  width: 150,
  height: 150
}, {
  name: 'siam-at-siam',
  src: 'siam_siam.webp',
  alt: 'Siam@Siam',
  width: 150,
  height: 150
}, {
  name: 'bon-cafe',
  src: 'bon_cafe.webp',
  alt: 'Bon Cafe',
  width: 150,
  height: 150
}, {
  name: 'owndays',
  src: 'owndays.webp',
  alt: 'Owndays',
  width: 150,
  height: 150
}];

var CustomerSection = function CustomerSection() {
  var _useLocale = (0,LocaleContext/* useLocale */.b)(),
      lang = _useLocale.lang;

  var ref = (0,react.useRef)(null);

  var _useState = (0,react.useState)(0),
      containerWidth = _useState[0],
      setContainerWidth = _useState[1];

  var calculateContainerWidth = (0,react.useCallback)(function () {
    if (ref.current) {
      var children = Array.from(ref.current.children);
      var totalWidth = children.reduce(function (sum, child) {
        var childWidth = child.getBoundingClientRect().width;
        return sum + childWidth;
      }, 0);
      setContainerWidth(totalWidth);
    }
  }, []);
  (0,react.useEffect)(function () {
    calculateContainerWidth();
    window.addEventListener('resize', calculateContainerWidth); // Clean up the event listener

    return function () {
      window.removeEventListener('resize', calculateContainerWidth);
    };
  }, [calculateContainerWidth]);
  var title = {
    en: "CODIUM is Thailand's #1 Digital Native Company as a Service, proudly delivering top-tier solutions to over 500 organizations.",
    th: 'CODIUM คือผู้ให้บริการ Digital Native Company as a Service อันดับ 1 ของประเทศไทย ที่ภาคภูมิใจให้บริการให้กับกว่า 500 องค์กรชั้นนำ'
  };
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
    "aria-labelledby": "customers",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: "Container text-p2Semibold text-center md:text-left text-lightBlue mb-10",
      children: title[lang]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "Container flex justify-center items-center",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(AutoSlide_AutoSlide, {
        containerWidth: containerWidth,
        duration: 40,
        pauseOnHover: false,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          ref: ref,
          className: "flex items-center gap-6",
          children: [].concat(customers, customers, customers).map(function (item, index) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "w-[80px] h-[80px] lg:w-[100px] lg:h-[100px] bg-[#FFFFFF0A] rounded-2xl flex items-center my-4",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
                src: "".concat(logoPath).concat(item.src),
                alt: item.alt,
                width: item.width,
                height: item.height,
                objectFit: 'contain',
                loading: "lazy"
              })
            }, index);
          })
        })
      })
    })]
  });
};

/* harmony default export */ var ServiceSection_CustomerSection = (CustomerSection);
// EXTERNAL MODULE: ./components/Contexts/TailwindBreakpointContext.tsx + 4 modules
var TailwindBreakpointContext = __webpack_require__(9806);
// EXTERNAL MODULE: ./node_modules/react-intersection-observer/dist/index.mjs
var dist = __webpack_require__(8357);
;// CONCATENATED MODULE: ./components/Home/ServiceSection/ESGService.tsx












var Tag = function Tag(_ref) {
  var text = _ref.text;
  return /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
    className: "bg-[#171F34] text-p2Medium lg:text-p1Medium text-lightBlue px-4 py-2.5 rounded-full",
    children: text
  });
};

var CardService = function CardService(_ref2) {
  var icon = _ref2.icon,
      title = _ref2.title,
      detail = _ref2.detail;

  var _useInView = (0,dist/* useInView */.YD)({
    threshold: 0.5,
    triggerOnce: true
  }),
      ref = _useInView.ref,
      inView = _useInView.inView;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    ref: ref,
    className: "h-full flex-column gap-5 rounded-[20px] bg-[#FFFFFF0A] p-6",
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
        style: {
          width: 'fit-content'
        },
        initial: {
          opacity: 0,
          scale: 1
        },
        animate: inView ? {
          opacity: 1,
          scale: [1, 1.2, 1],
          transition: {
            type: 'spring',
            duration: 1
          }
        } : {
          opacity: 0,
          scale: 1
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: icon,
          alt: title,
          width: 60,
          height: 60
        })
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
        className: "text-h5MobileSemiBold md:text-h4MobileSemiBold first-letter:text-lightBlue",
        children: title
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      className: "text-p2Regular",
      children: detail
    })]
  });
};

var ESGService = function ESGService() {
  var _useLocale = (0,LocaleContext/* useLocale */.b)(),
      lang = _useLocale.lang;

  var _useTailwindBreakpoin = (0,TailwindBreakpointContext/* useTailwindBreakpoint */._)(),
      screenWidth = _useTailwindBreakpoin.screenWidth;

  var _useState = (0,react.useState)(null),
      initWidth = _useState[0],
      setInitWidth = _useState[1];

  var _useState2 = (0,react.useState)(false),
      isHovered = _useState2[0],
      setIsHovered = _useState2[1];

  (0,react.useEffect)(function () {
    setInitWidth(window.innerWidth);
  }, []);
  (0,react.useEffect)(function () {
    if (screenWidth) {
      setInitWidth(null);
    }
  }, [screenWidth]);
  var title = {
    en: 'CODIUM ESG',
    th: 'CODIUM ESG'
  };
  var description = {
    en: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: ["We offer comprehensive services, including consultation, solution development, ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {
        className: "hidden md:block"
      }), "and tailored customization to meet the unique needs of your organization."]
    }),
    th: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: ["CODIUM \u0E43\u0E2B\u0E49\u0E1A\u0E23\u0E34\u0E01\u0E32\u0E23\u0E41\u0E1A\u0E1A\u0E04\u0E23\u0E1A\u0E27\u0E07\u0E08\u0E23 \u0E15\u0E31\u0E49\u0E07\u0E41\u0E15\u0E48\u0E01\u0E32\u0E23\u0E43\u0E2B\u0E49\u0E04\u0E33\u0E1B\u0E23\u0E36\u0E01\u0E29\u0E32 \u0E01\u0E32\u0E23\u0E1E\u0E31\u0E12\u0E19\u0E32\u0E42\u0E0B\u0E25\u0E39\u0E0A\u0E31\u0E19 \u0E41\u0E25\u0E30\u0E01\u0E32\u0E23\u0E1B\u0E23\u0E31\u0E1A\u0E41\u0E15\u0E48\u0E07\u0E43\u0E2B\u0E49\u0E40\u0E2B\u0E21\u0E32\u0E30\u0E2A\u0E21 ", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {
        className: "hidden md:block"
      }), "\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E23\u0E2D\u0E07\u0E23\u0E31\u0E1A\u0E04\u0E27\u0E32\u0E21\u0E15\u0E49\u0E2D\u0E07\u0E01\u0E32\u0E23\u0E40\u0E09\u0E1E\u0E32\u0E30\u0E02\u0E2D\u0E07\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23\u0E04\u0E38\u0E13"]
    })
  };
  var services = ['Consulting', 'Digitization Solutions', 'Custom Development'];
  var serviceInformation = [{
    src: '/images/new-homepage/money-bag.png',
    title: 'Earnings & Expenses',
    detail: {
      en: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: ["At CODIUM, we empower organizations with", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "good governance and transparency."
        }), " Our solutions enhance ", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "stability, sustainability, and security"
        }), ", ensuring ethical and effective operations that benefit both businesses and society."]
      }),
      th: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: ["\u0E17\u0E35\u0E48 CODIUM \u0E40\u0E23\u0E32\u0E0A\u0E48\u0E27\u0E22\u0E43\u0E2B\u0E49\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E07\u0E32\u0E19\u0E14\u0E49\u0E27\u0E22", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "\u0E18\u0E23\u0E23\u0E21\u0E32\u0E20\u0E34\u0E1A\u0E32\u0E25\u0E41\u0E25\u0E30\u0E04\u0E27\u0E32\u0E21\u0E42\u0E1B\u0E23\u0E48\u0E07\u0E43\u0E2A"
        }), " \u0E42\u0E0B\u0E25\u0E39\u0E0A\u0E31\u0E19\u0E02\u0E2D\u0E07\u0E40\u0E23\u0E32\u0E22\u0E01\u0E23\u0E30\u0E14\u0E31\u0E1A", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "\u0E40\u0E2A\u0E16\u0E35\u0E22\u0E23\u0E20\u0E32\u0E1E \u0E04\u0E27\u0E32\u0E21\u0E22\u0E31\u0E48\u0E07\u0E22\u0E37\u0E19 \u0E41\u0E25\u0E30\u0E04\u0E27\u0E32\u0E21\u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22"
        }), ' ', "\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E43\u0E2B\u0E49\u0E21\u0E31\u0E48\u0E19\u0E43\u0E08\u0E27\u0E48\u0E32\u0E01\u0E32\u0E23\u0E14\u0E33\u0E40\u0E19\u0E34\u0E19\u0E18\u0E38\u0E23\u0E01\u0E34\u0E08\u0E40\u0E1B\u0E47\u0E19\u0E44\u0E1B\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E21\u0E35\u0E08\u0E23\u0E34\u0E22\u0E18\u0E23\u0E23\u0E21\u0E41\u0E25\u0E30\u0E21\u0E35\u0E1B\u0E23\u0E30\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E20\u0E32\u0E1E \u0E2A\u0E23\u0E49\u0E32\u0E07\u0E1C\u0E25\u0E1B\u0E23\u0E30\u0E42\u0E22\u0E0A\u0E19\u0E4C\u0E43\u0E2B\u0E49\u0E17\u0E31\u0E49\u0E07\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23\u0E41\u0E25\u0E30\u0E2A\u0E31\u0E07\u0E04\u0E21"]
      })
    }
  }, {
    src: '/icons/people-team.svg',
    title: 'Stakeholders',
    detail: {
      en: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: ["A reliable system fosters", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "transparency, reduces errors, and eliminates repetitive tasks"
        }), ", streamlining communication and boosting trust. The result? A seamless experience that truly supports and delights every stakeholder, keeping them genuinely", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "'Happy.'"
        })]
      }),
      th: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: ["\u0E23\u0E30\u0E1A\u0E1A\u0E17\u0E35\u0E48\u0E21\u0E35\u0E1B\u0E23\u0E30\u0E2A\u0E34\u0E17\u0E18\u0E34\u0E20\u0E32\u0E1E\u0E0A\u0E48\u0E27\u0E22\u0E2A\u0E48\u0E07\u0E40\u0E2A\u0E23\u0E34\u0E21", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "\u0E04\u0E27\u0E32\u0E21\u0E42\u0E1B\u0E23\u0E48\u0E07\u0E43\u0E2A \u0E25\u0E14\u0E02\u0E49\u0E2D\u0E1C\u0E34\u0E14\u0E1E\u0E25\u0E32\u0E14 \u0E41\u0E25\u0E30\u0E02\u0E08\u0E31\u0E14\u0E07\u0E32\u0E19\u0E0B\u0E49\u0E33\u0E0B\u0E49\u0E2D\u0E19"
        }), ' ', "\u0E17\u0E33\u0E43\u0E2B\u0E49\u0E01\u0E32\u0E23\u0E2A\u0E37\u0E48\u0E2D\u0E2A\u0E32\u0E23\u0E23\u0E32\u0E1A\u0E23\u0E37\u0E48\u0E19\u0E41\u0E25\u0E30\u0E40\u0E1E\u0E34\u0E48\u0E21\u0E04\u0E27\u0E32\u0E21\u0E44\u0E27\u0E49\u0E27\u0E32\u0E07\u0E43\u0E08 \u0E1C\u0E25\u0E25\u0E31\u0E1E\u0E18\u0E4C\u0E04\u0E37\u0E2D\u0E1B\u0E23\u0E30\u0E2A\u0E1A\u0E01\u0E32\u0E23\u0E13\u0E4C\u0E17\u0E35\u0E48\u0E44\u0E23\u0E49\u0E23\u0E2D\u0E22\u0E15\u0E48\u0E2D \u0E0A\u0E48\u0E27\u0E22\u0E43\u0E2B\u0E49\u0E17\u0E38\u0E01\u0E1D\u0E48\u0E32\u0E22\u0E17\u0E35\u0E48\u0E40\u0E01\u0E35\u0E48\u0E22\u0E27\u0E02\u0E49\u0E2D\u0E07\u0E44\u0E14\u0E49\u0E23\u0E31\u0E1A\u0E01\u0E32\u0E23\u0E2A\u0E19\u0E31\u0E1A\u0E2A\u0E19\u0E38\u0E19\u0E41\u0E25\u0E30\u0E1E\u0E36\u0E07\u0E1E\u0E2D\u0E43\u0E08\u0E2D\u0E22\u0E48\u0E32\u0E07\u0E41\u0E17\u0E49\u0E08\u0E23\u0E34\u0E07 \u0E17\u0E33\u0E43\u0E2B\u0E49\u0E17\u0E38\u0E01\u0E04\u0E19 ", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "'Happy'"
        }), " \u0E2D\u0E22\u0E48\u0E32\u0E07\u0E41\u0E17\u0E49\u0E08\u0E23\u0E34\u0E07"]
      })
    }
  }, {
    src: '/icons/classical-building.svg',
    title: 'Governance',
    detail: {
      en: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: ["At CODIUM, we help organizations achieve", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "good governance and transparency"
        }), " with solutions that enhance stability and sustainability. Beyond profitability, we foster ", /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "ethical, secure, and transparent"
        }), " systems for long-term impact."]
      }),
      th: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: ["\u0E17\u0E35\u0E48 CODIUM \u0E40\u0E23\u0E32\u0E0A\u0E48\u0E27\u0E22\u0E43\u0E2B\u0E49\u0E2D\u0E07\u0E04\u0E4C\u0E01\u0E23\u0E1A\u0E23\u0E23\u0E25\u0E38", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "\u0E18\u0E23\u0E23\u0E21\u0E32\u0E20\u0E34\u0E1A\u0E32\u0E25\u0E41\u0E25\u0E30\u0E04\u0E27\u0E32\u0E21\u0E42\u0E1B\u0E23\u0E48\u0E07\u0E43\u0E2A"
        }), ' ', "\u0E1C\u0E48\u0E32\u0E19\u0E42\u0E0B\u0E25\u0E39\u0E0A\u0E31\u0E19\u0E17\u0E35\u0E48\u0E40\u0E2A\u0E23\u0E34\u0E21\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E40\u0E2A\u0E16\u0E35\u0E22\u0E23\u0E20\u0E32\u0E1E\u0E41\u0E25\u0E30\u0E04\u0E27\u0E32\u0E21\u0E22\u0E31\u0E48\u0E07\u0E22\u0E37\u0E19 \u0E44\u0E21\u0E48\u0E40\u0E1E\u0E35\u0E22\u0E07\u0E41\u0E04\u0E48\u0E1C\u0E25\u0E01\u0E33\u0E44\u0E23\u0E40\u0E17\u0E48\u0E32\u0E19\u0E31\u0E49\u0E19 \u0E40\u0E23\u0E32\u0E21\u0E38\u0E48\u0E07\u0E40\u0E19\u0E49\u0E19\u0E01\u0E32\u0E23\u0E1E\u0E31\u0E12\u0E19\u0E32", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("strong", {
          children: "\u0E23\u0E30\u0E1A\u0E1A\u0E17\u0E35\u0E48\u0E21\u0E35\u0E08\u0E23\u0E34\u0E22\u0E18\u0E23\u0E23\u0E21 \u0E1B\u0E25\u0E2D\u0E14\u0E20\u0E31\u0E22 \u0E41\u0E25\u0E30\u0E42\u0E1B\u0E23\u0E48\u0E07\u0E43\u0E2A"
        }), ' ', "\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E2A\u0E23\u0E49\u0E32\u0E07\u0E1C\u0E25\u0E01\u0E23\u0E30\u0E17\u0E1A\u0E40\u0E0A\u0E34\u0E07\u0E1A\u0E27\u0E01\u0E43\u0E19\u0E23\u0E30\u0E22\u0E30\u0E22\u0E32\u0E27"]
      })
    }
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    "aria-labelledby": "esg-service",
    children: /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "Container flex-column gap-12 lg:gap-24",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        className: "flex-column gap-10",
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
          className: "flex-column gap-5",
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Common/* Title */.D, {
            children: title[lang]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            className: "p-text text-center",
            children: description[lang]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
            className: "flex flex-wrap md:justify-center items-center gap-2.5",
            children: services.map(function (service) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)(Tag, {
                text: service
              }, service);
            })
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "lg:hidden",
          onMouseEnter: function onMouseEnter() {
            return setIsHovered(true);
          },
          onMouseLeave: function onMouseLeave() {
            return setIsHovered(false);
          },
          onTouchStart: function onTouchStart() {
            return setIsHovered(true);
          },
          onTouchEnd: function onTouchEnd() {
            return setIsHovered(false);
          },
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(CarouselNewDesign_CarouselNewDesign, {
            percent_width: 100,
            position_x: initWidth >= 768 || screenWidth >= 768 ? 50 : 100,
            interval: 5000,
            autoSlide: true,
            isHovered: isHovered,
            currentSlide: function currentSlide() {},
            children: serviceInformation.map(function (service) {
              return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
                className: "md:px-2.5 md:max-w-[50%]",
                style: {
                  flex: '1 0 100%'
                },
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(CardService, {
                  icon: service.src,
                  title: service.title,
                  detail: service.detail[lang]
                })
              }, service.title);
            })
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "hidden lg:flex gap-8",
          children: serviceInformation.map(function (service) {
            return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
              className: "flex-1",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(CardService, {
                icon: service.src,
                title: service.title,
                detail: service.detail[lang]
              })
            }, service.title);
          })
        })]
      })
    })
  });
};

/* harmony default export */ var ServiceSection_ESGService = (ESGService);
;// CONCATENATED MODULE: ./components/Home/ServiceSection/SoftwareSolutionService.tsx









var ProductDetail = function ProductDetail(_ref) {
  var product = _ref.product,
      lang = _ref.lang;

  var _useInView = (0,dist/* useInView */.YD)({
    threshold: 0.5,
    triggerOnce: true
  }),
      ref = _useInView.ref,
      inView = _useInView.inView;

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    ref: ref,
    className: "flex-column items-center gap-6 md:".concat(product.reverse ? 'flex-row-reverse' : 'flex-row'),
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "flex-1 flex-column gap-6",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
          className: "text-h4MobileSemiBold md:text-h3MobileSemiBold mb-2",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)("span", {
            className: "gradient-head-large",
            children: product.name
          })
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.h4 */.E.h4, {
          className: "text-p2Medium lg:text-p1Medium overflow-hidden",
          initial: {
            opacity: 0
          },
          animate: inView ? {
            opacity: 1,
            transition: {
              duration: 0.7
            }
          } : {
            opacity: 0
          },
          children: product.description[lang]
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
        className: "text-p2Regular",
        children: product.detail[lang]
      })]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "flex-1 lg:flex-none lg:w-[38%] flex justify-center items-center",
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(motion/* motion.div */.E.div, {
        initial: {
          opacity: 0,
          x: product.reverse ? -40 : 40
        },
        animate: inView ? {
          opacity: 1,
          x: 0,
          transition: {
            duration: 0.7,
            delay: 0.3
          }
        } : {
          opacity: 0,
          x: product.reverse ? -40 : 40
        },
        children: /*#__PURE__*/(0,jsx_runtime.jsx)((image_default()), {
          src: product.src,
          alt: product.name,
          width: 423,
          height: 211,
          objectFit: 'contain',
          loading: "lazy"
        })
      })
    })]
  });
};

var SoftwareSolutionService = function SoftwareSolutionService() {
  var _useLocale = (0,LocaleContext/* useLocale */.b)(),
      lang = _useLocale.lang;

  var title = {
    en: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: ["Tailored Software Solutions,", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("br", {
        className: "hidden md:block lg:hidden"
      }), "Built for Your 'Business'."]
    }),
    th: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
      children: ["\u0E42\u0E0B\u0E25\u0E39\u0E0A\u0E31\u0E19\u0E0B\u0E2D\u0E1F\u0E15\u0E4C\u0E41\u0E27\u0E23\u0E4C\u0E17\u0E35\u0E48\u0E2D\u0E2D\u0E01\u0E41\u0E1A\u0E1A\u0E40\u0E09\u0E1E\u0E32\u0E30", ' ', /*#__PURE__*/(0,jsx_runtime.jsx)("br", {
        className: "hidden md:block lg:hidden"
      }), "\u0E40\u0E1E\u0E37\u0E48\u0E2D\u0E18\u0E38\u0E23\u0E01\u0E34\u0E08\u0E02\u0E2D\u0E07\u0E04\u0E38\u0E13"]
    })
  };
  var productDetail = [{
    src: '/images/new-homepage/e-memo.webp',
    name: 'e-Memo',
    description: {
      en: 'Electronic approval and workflow',
      th: 'ระบบจัดการเอกสารออนไลน์เเละลงลายมือชื่ออิเล็กทรอนิกส์ '
    },
    detail: {
      en: 'Effortlessly and securely manage all your documents with ease. Our system is designed to adapt seamlessly to the complexity of your organization’s internal structure, fully supporting your paperless transformation. Experience the freedom of accessing and approving documents anytime, anywhere, with enhanced efficiency and convenience.',
      th: 'เซ็นอนุมัติเอกสารได้จากทุกที่ ทุกเวลา ครบทุกขั้นตอนงานเอกสารในที่เดียว สอดคล้องตามข้อกฎหมาย อำนวยความสะดวกพนักงานทุกคนแผนกในการทำงาน'
    },
    reverse: false
  }, {
    src: '/images/new-homepage/e-tax.webp',
    name: 'e-Tax',
    description: {
      en: 'All-in-one tax management system',
      th: 'ระบบออกใบกำกับภาษีรูปแบบอิเล็กทรอนิกส์'
    },
    detail: {
      en: 'An e-tax & e-receipt system designed for organizations: user-friendly, secure, and fully compliant with legal requirements. Effortlessly integrate via API for seamless connectivity with accounting systems and ERPs.',
      th: 'ระบบออกใบกำกับภาษีรูปแบบอิเล็กทรอนิกส์สำหรับองค์กร ใช้งานง่าย ปลอดภัย มาตราฐานตรงตามข้อกำหนดกฎหมาย แค่เชื่อม API ก็สามารถต่อกับระบบบัญชีและ ERP ทุกระบบ'
    },
    reverse: true
  }, {
    src: '/images/new-homepage/e-contract.webp',
    name: 'e-Contract',
    description: {
      en: 'Legally binding digital contracts',
      th: 'ระบบทำสัญญาดิจิทัล'
    },
    detail: {
      en: 'Embrace the future with our e-Contract platform—the first in Thailand to provide a legally-binding digital contract service. Streamline your workflow with e-Signatures, video identification, and legally recognized e-Timestamps. Say goodbye to the inefficiencies of traditional paperwork, save time, minimize errors, and take your business fully digital!',
      th: 'ก้าวสู่อนาคตด้วยแพลตฟอร์ม e-Contract ของเรา แพลตฟอร์มแรกในประเทศไทยที่ให้บริการสัญญาดิจิทัลที่มีผลผูกพันทางกฎหมาย ปรับปรุงกระบวนการทำงานของคุณให้มีประสิทธิภาพด้วย e-Signatures การยืนยันตัวตนผ่านวิดีโอ และ e-Timestamps ที่ได้รับการยอมรับทางกฎหมาย บอกลาความยุ่งยากของเอกสารแบบเดิม ประหยัดเวลา ลดความผิดพลาด และนำธุรกิจของคุณเข้าสู่ยุคดิจิทัลอย่างเต็มรูปแบบ!'
    },
    reverse: false
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsx)("section", {
    "aria-labelledby": "software-solution-service",
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "Container flex-column gap-10",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Common/* Title */.D, {
        children: title[lang]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: "flex-column gap-20",
        children: productDetail.map(function (product) {
          return /*#__PURE__*/(0,jsx_runtime.jsx)(ProductDetail, {
            product: product,
            lang: lang
          }, product.name);
        })
      })]
    })
  });
};

/* harmony default export */ var ServiceSection_SoftwareSolutionService = (SoftwareSolutionService);
;// CONCATENATED MODULE: ./components/Home/ServiceSection/ServiceSection.tsx







var ServiceSection = function ServiceSection() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
    className: "relative",
    "aria-labelledby": "services",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "absolute h-full",
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("video", {
        autoPlay: true,
        muted: true,
        loop: true,
        playsInline: true,
        "aria-label": "Digital transformation background video",
        style: {
          objectFit: 'cover',
          width: '100%',
          height: '100%'
        },
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("source", {
          src: "/videos/homepage-bg-video-2.mp4",
          type: "video/mp4"
        }), "Your browser does not support the video tag."]
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "absolute inset-0 w-full h-full flex justify-center items-center bg-[#000000] opacity-40"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      className: "absolute inset-0 w-full h-full flex justify-center items-center",
      style: {
        background: 'linear-gradient(180deg, #0A1027 0%, rgba(10, 16, 39, 0) 38.73%)'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      className: "relative flex-column gap-12 xxl:gap-24 px-2 py-12",
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ServiceSection_ESGService, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(ServiceSection_SoftwareSolutionService, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(ServiceSection_CustomerSection, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(ServiceSection_BusinessOutcomes, {})]
    })]
  });
};

/* harmony default export */ var ServiceSection_ServiceSection = (ServiceSection);
;// CONCATENATED MODULE: ./components/Home/Home.tsx








var Home = function Home() {
  var _useState = (0,react.useState)(false),
      scroll = _useState[0],
      setScroll = _useState[1];

  var scrollToContact = function scrollToContact() {
    setScroll(!scroll);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsxs)("main", {
    className: "pt-[3rem] md:pt-[3.5rem] bg-[#0A1026] text-white",
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(HeroSection_HeroSection, {
      click: scrollToContact
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(DigitalTransformationSection_DigitalTransformationSection, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(ServiceSection_ServiceSection, {}), /*#__PURE__*/(0,jsx_runtime.jsx)(FormContact/* default */.Z, {
      product: "HOMEPAGE",
      event: "homepageFormSubmit",
      scroll: scroll
    })]
  });
};

/* harmony default export */ var Home_Home = (Home);
;// CONCATENATED MODULE: ./components/Home/index.ts

// EXTERNAL MODULE: ./components/Contexts/HomeContext.tsx
var HomeContext = __webpack_require__(4269);
// EXTERNAL MODULE: ./components/_OldDesign/header.tsx + 1 modules
var header = __webpack_require__(6627);
;// CONCATENATED MODULE: ./pages/index.tsx








var HomePage = function HomePage(state) {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(header/* default */.Z, {
      content: {
        title: 'CODIUM - ผู้ให้บริการ Digital Native as a Service ชั้นนำ',
        content: 'ผู้นำด้านโซลูชัน Digital Workflow บริการครบวงจร เช่น e-Memo, e-Tax และ e-Contract เพื่อขับเคลื่อนองค์กรของคุณสู่ยุคดิจิทัลอย่างมั่นใจ',
        image: null
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(HomeContext/* HomeContext.Provider */.Q.Provider, {
      value: state,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Home_Home, {})
    })]
  });
};

HomePage.getLayout = function (page) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Layout/* Layout */.A, {
    children: page
  });
};

var __N_SSG = true;
/* harmony default export */ var pages = (HomePage);

/***/ }),

/***/ 8312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(8008);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 7037:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ useInView; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/utils/resolve-elements.es.js
function resolveElements(elements, selectorCache) {
    var _a;
    if (typeof elements === "string") {
        if (selectorCache) {
            (_a = selectorCache[elements]) !== null && _a !== void 0 ? _a : (selectorCache[elements] = document.querySelectorAll(elements));
            elements = selectorCache[elements];
        }
        else {
            elements = document.querySelectorAll(elements);
        }
    }
    else if (elements instanceof Element) {
        elements = [elements];
    }
    /**
     * Return an empty array
     */
    return Array.from(elements || []);
}



;// CONCATENATED MODULE: ./node_modules/@motionone/utils/dist/is-function.es.js
const isFunction = (value) => typeof value === "function";



;// CONCATENATED MODULE: ./node_modules/@motionone/dom/dist/gestures/in-view.es.js



const thresholds = {
    any: 0,
    all: 1,
};
function inView(elementOrSelector, onStart, { root, margin: rootMargin, amount = "any" } = {}) {
    /**
     * If this browser doesn't support IntersectionObserver, return a dummy stop function.
     * Default triggering of onStart is tricky - it could be used for starting/stopping
     * videos, lazy loading content etc. We could provide an option to enable a fallback, or
     * provide a fallback callback option.
     */
    if (typeof IntersectionObserver === "undefined") {
        return () => { };
    }
    const elements = resolveElements(elementOrSelector);
    const activeIntersections = new WeakMap();
    const onIntersectionChange = (entries) => {
        entries.forEach((entry) => {
            const onEnd = activeIntersections.get(entry.target);
            /**
             * If there's no change to the intersection, we don't need to
             * do anything here.
             */
            if (entry.isIntersecting === Boolean(onEnd))
                return;
            if (entry.isIntersecting) {
                const newOnEnd = onStart(entry);
                if (isFunction(newOnEnd)) {
                    activeIntersections.set(entry.target, newOnEnd);
                }
                else {
                    observer.unobserve(entry.target);
                }
            }
            else if (onEnd) {
                onEnd(entry);
                activeIntersections.delete(entry.target);
            }
        });
    };
    const observer = new IntersectionObserver(onIntersectionChange, {
        root,
        rootMargin,
        threshold: typeof amount === "number" ? amount : thresholds[amount],
    });
    elements.forEach((element) => observer.observe(element));
    return () => observer.disconnect();
}



;// CONCATENATED MODULE: ./node_modules/framer-motion/dist/es/utils/use-in-view.mjs



function useInView(ref, { root, margin, amount, once = false } = {}) {
    const [isInView, setInView] = (0,react.useState)(false);
    (0,react.useEffect)(() => {
        if (!ref.current || (once && isInView))
            return;
        const onEnter = () => {
            setInView(true);
            return once ? undefined : () => setInView(false);
        };
        const options = {
            root: (root && root.current) || undefined,
            margin,
            amount: amount === "some" ? "any" : amount,
        };
        return inView(ref.current, onEnter, options);
    }, [root, ref, margin, once]);
    return isInView;
}




/***/ }),

/***/ 8357:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "YD": function() { return /* binding */ useInView; }
/* harmony export */ });
/* unused harmony exports InView, defaultFallbackInView, observe */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
"use client";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);

// src/InView.tsx


// src/observe.ts
var observerMap = /* @__PURE__ */ new Map();
var RootIds = /* @__PURE__ */ new WeakMap();
var rootId = 0;
var unsupportedValue = void 0;
function defaultFallbackInView(inView) {
  unsupportedValue = inView;
}
function getRootId(root) {
  if (!root) return "0";
  if (RootIds.has(root)) return RootIds.get(root);
  rootId += 1;
  RootIds.set(root, rootId.toString());
  return RootIds.get(root);
}
function optionsToId(options) {
  return Object.keys(options).sort().filter(
    (key) => options[key] !== void 0
  ).map((key) => {
    return `${key}_${key === "root" ? getRootId(options.root) : options[key]}`;
  }).toString();
}
function createObserver(options) {
  const id = optionsToId(options);
  let instance = observerMap.get(id);
  if (!instance) {
    const elements = /* @__PURE__ */ new Map();
    let thresholds;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        var _a;
        const inView = entry.isIntersecting && thresholds.some((threshold) => entry.intersectionRatio >= threshold);
        if (options.trackVisibility && typeof entry.isVisible === "undefined") {
          entry.isVisible = inView;
        }
        (_a = elements.get(entry.target)) == null ? void 0 : _a.forEach((callback) => {
          callback(inView, entry);
        });
      });
    }, options);
    thresholds = observer.thresholds || (Array.isArray(options.threshold) ? options.threshold : [options.threshold || 0]);
    instance = {
      id,
      observer,
      elements
    };
    observerMap.set(id, instance);
  }
  return instance;
}
function observe(element, callback, options = {}, fallbackInView = unsupportedValue) {
  if (typeof window.IntersectionObserver === "undefined" && fallbackInView !== void 0) {
    const bounds = element.getBoundingClientRect();
    callback(fallbackInView, {
      isIntersecting: fallbackInView,
      target: element,
      intersectionRatio: typeof options.threshold === "number" ? options.threshold : 0,
      time: 0,
      boundingClientRect: bounds,
      intersectionRect: bounds,
      rootBounds: bounds
    });
    return () => {
    };
  }
  const { id, observer, elements } = createObserver(options);
  const callbacks = elements.get(element) || [];
  if (!elements.has(element)) {
    elements.set(element, callbacks);
  }
  callbacks.push(callback);
  observer.observe(element);
  return function unobserve() {
    callbacks.splice(callbacks.indexOf(callback), 1);
    if (callbacks.length === 0) {
      elements.delete(element);
      observer.unobserve(element);
    }
    if (elements.size === 0) {
      observer.disconnect();
      observerMap.delete(id);
    }
  };
}

// src/InView.tsx
function isPlainChildren(props) {
  return typeof props.children !== "function";
}
var InView = class extends react__WEBPACK_IMPORTED_MODULE_0__.Component {
  constructor(props) {
    super(props);
    __publicField(this, "node", null);
    __publicField(this, "_unobserveCb", null);
    __publicField(this, "handleNode", (node) => {
      if (this.node) {
        this.unobserve();
        if (!node && !this.props.triggerOnce && !this.props.skip) {
          this.setState({ inView: !!this.props.initialInView, entry: void 0 });
        }
      }
      this.node = node ? node : null;
      this.observeNode();
    });
    __publicField(this, "handleChange", (inView, entry) => {
      if (inView && this.props.triggerOnce) {
        this.unobserve();
      }
      if (!isPlainChildren(this.props)) {
        this.setState({ inView, entry });
      }
      if (this.props.onChange) {
        this.props.onChange(inView, entry);
      }
    });
    this.state = {
      inView: !!props.initialInView,
      entry: void 0
    };
  }
  componentDidMount() {
    this.unobserve();
    this.observeNode();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.rootMargin !== this.props.rootMargin || prevProps.root !== this.props.root || prevProps.threshold !== this.props.threshold || prevProps.skip !== this.props.skip || prevProps.trackVisibility !== this.props.trackVisibility || prevProps.delay !== this.props.delay) {
      this.unobserve();
      this.observeNode();
    }
  }
  componentWillUnmount() {
    this.unobserve();
  }
  observeNode() {
    if (!this.node || this.props.skip) return;
    const {
      threshold,
      root,
      rootMargin,
      trackVisibility,
      delay,
      fallbackInView
    } = this.props;
    this._unobserveCb = observe(
      this.node,
      this.handleChange,
      {
        threshold,
        root,
        rootMargin,
        // @ts-ignore
        trackVisibility,
        // @ts-ignore
        delay
      },
      fallbackInView
    );
  }
  unobserve() {
    if (this._unobserveCb) {
      this._unobserveCb();
      this._unobserveCb = null;
    }
  }
  render() {
    const { children } = this.props;
    if (typeof children === "function") {
      const { inView, entry } = this.state;
      return children({ inView, entry, ref: this.handleNode });
    }
    const {
      as,
      triggerOnce,
      threshold,
      root,
      rootMargin,
      onChange,
      skip,
      trackVisibility,
      delay,
      initialInView,
      fallbackInView,
      ...props
    } = this.props;
    return React.createElement(
      as || "div",
      { ref: this.handleNode, ...props },
      children
    );
  }
};

// src/useInView.tsx

function useInView({
  threshold,
  delay,
  trackVisibility,
  rootMargin,
  root,
  triggerOnce,
  skip,
  initialInView,
  fallbackInView,
  onChange
} = {}) {
  var _a;
  const [ref, setRef] = react__WEBPACK_IMPORTED_MODULE_0__.useState(null);
  const callback = react__WEBPACK_IMPORTED_MODULE_0__.useRef(onChange);
  const [state, setState] = react__WEBPACK_IMPORTED_MODULE_0__.useState({
    inView: !!initialInView,
    entry: void 0
  });
  callback.current = onChange;
  react__WEBPACK_IMPORTED_MODULE_0__.useEffect(
    () => {
      if (skip || !ref) return;
      let unobserve;
      unobserve = observe(
        ref,
        (inView, entry) => {
          setState({
            inView,
            entry
          });
          if (callback.current) callback.current(inView, entry);
          if (entry.isIntersecting && triggerOnce && unobserve) {
            unobserve();
            unobserve = void 0;
          }
        },
        {
          root,
          rootMargin,
          threshold,
          // @ts-ignore
          trackVisibility,
          // @ts-ignore
          delay
        },
        fallbackInView
      );
      return () => {
        if (unobserve) {
          unobserve();
        }
      };
    },
    // We break the rule here, because we aren't including the actual `threshold` variable
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      // If the threshold is an array, convert it to a string, so it won't change between renders.
      Array.isArray(threshold) ? threshold.toString() : threshold,
      ref,
      root,
      rootMargin,
      triggerOnce,
      skip,
      trackVisibility,
      fallbackInView,
      delay
    ]
  );
  const entryTarget = (_a = state.entry) == null ? void 0 : _a.target;
  const previousEntryTarget = react__WEBPACK_IMPORTED_MODULE_0__.useRef(void 0);
  if (!ref && entryTarget && !triggerOnce && !skip && previousEntryTarget.current !== entryTarget) {
    previousEntryTarget.current = entryTarget;
    setState({
      inView: !!initialInView,
      entry: void 0
    });
  }
  const result = [setRef, state.inView, state.entry];
  result.ref = result[0];
  result.inView = result[1];
  result.entry = result[2];
  return result;
}

//# sourceMappingURL=index.mjs.map

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [735,859,467,60,5,878,774,888,179], function() { return __webpack_exec__(8312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);